const {registerModule} = window;

class ScrollTracker {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  createScrollWatcher(scrollTriggerThresholds, callback) {
    const listener = () => {
      const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const percent = (scrollTop / (scrollHeight - clientHeight)) * 100;
      scrollTriggerThresholds.forEach((threshold) => {
        if (percent >= threshold.percent) {
          callback(threshold);
        }
      });
    };
    document.addEventListener('scroll', listener, false);
    return {remove: () => {
      document.removeEventListener('scroll', listener, false);
    }};
  }

  allScrollEventsFired() {
    return this.scrollTriggerThresholds.every((threshold) => {
      return this.triggeredScrollEvents[threshold.percent];
    },
    );
  }

  sendMarketoVideoTrackingEvent(scrollEvent) {
    const domain = location.protocol + '//' + location.host;
    const data = {
      url: `${location.href.substring(domain.length)}`,
      params: `scroll-percent=${encodeURIComponent(scrollEvent.percent)}percentscrolled`,
    };
    window.Munchkin.munchkinFunction('visitWebPage', data);
    window.DD_LOGS && window.DD_LOGS.onReady(() => window.DD_LOGS.logger.info('marketo.visitWebPage', data));
  }

  waitForMunchkin(settings, onSuccess, onError) {
    if (window.Munchkin) {
      onSuccess();
    } else if (settings.maxTries - 1 <= 0) {
      onError();
    } else {
      setTimeout(() => {
        this.waitForMunchkin({interval: settings.interval, maxTries: settings.maxTries - 1}, onSuccess, onError);
      }, settings.interval);
    }
  }

  enableScrollTracking() {
    this.waitForMunchkin(this.waitForMunchkinSettings, () => {
      this.scrollWatcher = this.createScrollWatcher(this.scrollTriggerThresholds, (scrollEvent) => {
        if (this.allScrollEventsFired() === false) {
          if (!this.triggeredScrollEvents[scrollEvent.percent]) {
            this.sendMarketoVideoTrackingEvent(scrollEvent);
            this.triggeredScrollEvents[scrollEvent.percent] = true;
          }
        } else {
          this.scrollWatcher.remove();
        }
      });
    }, () => {
      console.error('Munchkin not available.');
    });
  }
  initialize() {
    this.setVars();
    const thisValue = this;
    if (document.readyState !== 'loading') {
      thisValue.enableScrollTracking();
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        thisValue.enableScrollTracking();
      });
    }
  }

  setVars() {
    this.scrollTriggerThresholds = [{percent: 40}, {percent: 80}];
    this.triggeredScrollEvents = {};
    this.waitForMunchkinSettings = {
      interval: 3000,
      maxTries: 5,
    };
  }
}

registerModule('ScrollTracker', ScrollTracker);
